var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"app-overlay",attrs:{"id":"app-overlay"}},[_c('font-awesome-icon',{staticClass:"spinner fa-spin",attrs:{"icon":"fa-solid fa-spinner"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }